export default __webpack_public_path__ + "static/blob4-6e5e8f8a9da554d8884498a8b877ec05.svg";